import { ApprovalLikelihood } from './odds';

/**
 * Shared between the client (query param -> header) and the BFF (header -> bypass),
 * so the two sides can't drift on the literal names.
 *
 * Skips Spinwheel connect/verify calls and returns a fixture odds map on the paid odds POST.
 * Session cookies are still set/marked/cleared as usual.
 *
 * Gated server-side to an explicit non-prod allowlist.
 */
export const SPINWHEEL_BYPASS_QUERY_PARAM = 'bypass_sw';
export const SPINWHEEL_BYPASS_HEADER = 'x-spinwheel-bypass';

// Bypass odds are keyed by synthetic ids (the BFF doesn't know the page's offers);
// the client maps these tiers onto real product ids.
export const SPINWHEEL_BYPASS_ODDS_ID_PREFIX = 'spinwheel-bypass-';

// Optional: `?bypass_sw_odds=poor` forces every card badge to one tier.
export const SPINWHEEL_BYPASS_ODDS_QUERY_PARAM = 'bypass_sw_odds';

const SPINWHEEL_BYPASS_ODDS_TIERS: Record<string, ApprovalLikelihood> = {
  excellent: ApprovalLikelihood.EXCELLENT_AO,
  good: ApprovalLikelihood.GOOD_AO,
  fair: ApprovalLikelihood.FAIR_AO,
  poor: ApprovalLikelihood.POOR_AO,
};

export function isSpinwheelBypassOddsId(id: string): boolean {
  return id.startsWith(SPINWHEEL_BYPASS_ODDS_ID_PREFIX);
}

export function parseSpinwheelBypassOddsTier(value: string | null): ApprovalLikelihood | undefined {
  if (!value) {
    return undefined;
  }

  return SPINWHEEL_BYPASS_ODDS_TIERS[value.trim().toLowerCase()];
}

// Explicit allowlist. Do not route this through deployableEnvSchema: that schema falls back to
// 'dev' when NEXT_PUBLIC_DEPLOYABLE_ENV is missing or invalid, which would enable the bypass.
const SPINWHEEL_BYPASS_ALLOWED_ENVS = new Set(['dev', 'local', 'stage']);

export function isSpinwheelBypassAllowedForEnv(deployableEnv: string | undefined): boolean {
  if (!deployableEnv) {
    return false;
  }

  return SPINWHEEL_BYPASS_ALLOWED_ENVS.has(deployableEnv);
}

export function isSpinwheelBypassRequested(headerValue: string | null): boolean {
  return headerValue === 'true';
}
